var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{
    name: 'menu',
    hash: `#${_vm.slug(_vm.name.replace(/^\d/, 'abc$&'))}`,
  }}},[_c('v-img',{class:_vm.getDefaultImage(),attrs:{"alt":_vm.name,"width":_vm.imageWidth,"height":"165","src":_vm.src || ''}},[_c('v-card-title',{staticClass:"flex-nowrap font-weight-bold menu-category-header-background py-2 primary--text"},[_c('div',{staticClass:"text-truncate"},[_vm._v(_vm._s(_vm.name))]),_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-chevron-right")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }